import React from "react";
import Svg from "./svg";

export default class CloseIcon extends Svg {
    render() {
        return (
            <svg
                className="close-icon"
                width="32"
                height="32"
                enableBackground="new 0 0 100 100"
                version="1.1"
                viewBox="0 0 100 100"
                xmlSpace="preserve"
                xmlns="http://www.w3.org/2000/svg"
                xmlnsXlink="http://www.w3.org/1999/xlink">

                <polygon
                    fill={this.props.color}
                    points="
                        77.6,21.1
                        49.6,49.2
                        21.5,21.1
                        19.6,23
                        47.6,51.1
                        19.6,79.2
                        21.5,81.1
                        49.6,53
                        77.6,81.1
                        79.6,79.2
                        51.5,51.1
                        79.6,23" />
            </svg>
        );
    }
}


/** WEBPACK FOOTER **
 ** ./src/widgets/appointment-widget/svg/close.js
 **/